// import NavigateBack from '../components/navigateBack';
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LanguageOptions } from "../../models/LanguageOptions";

import UpdateLanguage3 from "./updateLanguage3";

function LangPrefPage2({ data }) {
  // let history = useHistory();
  // const { i18n } = useTranslation();

  //TODO: Handle on submission logic
  // const navigateToOnboarding = (data) => {
  //     i18n.changeLanguage(data.value)
  //     history.replace({
  //         pathname: "/onboarding",
  //     })
  // };

  // const getDefaultChoice = () => {
  //     const defaultLang = new LanguageOptions()
  //         .options
  //         .filter(option => option.code === i18n.language)
  //         .first();
  //     return {
  //         value: defaultLang.code,
  //         text: defaultLang.name
  //     }
  // }

  return (
    <div>
      {/* <NavigateBack /> */}
      <UpdateLanguage3 {...data} />
    </div>
  );
}

export default LangPrefPage2;
